module.exports = __webpack_public_path__ + "img/residentList3.34d7b01d.png";